import React from "react";
import { createPortal } from "react-dom";
import { getReactPortalRoot } from "../utils/reactPortalRoot.js";
import "./ReassignmentPopover.css";
import ReassignmentPopoverContent from "./reassignment/ReassignmentPopoverContent.jsx";
import ReassignmentPopoverHeader from "./reassignment/ReassignmentPopoverHeader.jsx";
import useReassignmentPopoverController from "../hooks/useReassignmentPopoverController.js";

export default function ReassignmentPopover({
  anchorElement = null,
  contexts = [],
  error = null,
  inlineStatus = null,
  isOpen = true,
  loading = false,
  onClose,
  onReassign,
  placement = "bottom-start",
  rebuildMode = "complete",
  stepId = null,
  stepType = null,
}) {
  const {
    contentProps,
    floatingStyles,
    headerProps,
    isPositioned,
    popoverWidthClass,
    shouldShowLoadingState,
    setFloatingRef,
  } = useReassignmentPopoverController({
    anchorElement,
    contexts,
    error,
    isOpen,
    loading,
    onClose,
    onReassign,
    placement,
    rebuildMode,
    stepId,
    stepType,
  });

  if (!isOpen) {
    return null;
  }

  return createPortal(
    <div
      ref={setFloatingRef}
      data-react-reassignment-popover="true"
      data-step-id={stepId ?? ""}
      data-step-type={stepType ?? ""}
      className={[
        "z-popover font-sans",
        popoverWidthClass,
        isPositioned ? "" : "pointer-events-none",
      ].join(" ")}
      style={{
        ...floatingStyles,
        visibility: isPositioned ? "visible" : "hidden",
      }}
    >
      <section
        aria-busy={headerProps.isLoading}
        aria-label="Réaffectation camion"
        className="overflow-hidden rounded-[4px] border border-line-soft bg-surface text-text shadow-card"
        role="dialog"
      >
        <div className="h-1 bg-accent" />
        <ReassignmentPopoverHeader {...headerProps} />
        <ReassignmentPopoverContent {...contentProps} inlineStatus={inlineStatus} shouldShowLoadingState={shouldShowLoadingState} />
      </section>
    </div>,
    getReactPortalRoot(),
  );
}
